import {post, postForm} from '../http';

export default {

	deployAssetsAndUpdateExternalServiceIntegrations(
		request: ConfigEditor.DeployRequest,
	): Promise<ConfigEditor.DeployResponse> {
		const {authorizationToken, ...data} = request;
		return post(`${__STUDIO_URL__}/configeditor/deploy`, data, authorizationToken);
	},

	exportAssets(request: ConfigEditor.RequestWithAssets): Promise<Blob> {
		const {authorizationToken, ...data} = request;
		return post(`${__STUDIO_URL__}/configeditor/export`, data, authorizationToken);
	},

	importAssets(request: ConfigEditor.ImportRequest): Promise<ConfigEditor.AssetFiles> {
		const {authorizationToken, ...data} = request;
		return postForm(`${__STUDIO_URL__}/configeditor/import`, data, authorizationToken);
	},

	validateAssets(request: ConfigEditor.RequestWithAssets): Promise<ConfigEditor.AssetFiles> {
		const {authorizationToken, ...data} = request;
		return post(`${__STUDIO_URL__}/configeditor/validate`, data, authorizationToken);
	},

} as ConfigEditor.DeployApi;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/api/config-editor/deploy.ts